jQuery(document).ready(function ($) {
  console.log("jquery document ready");

  // Close mobile menu when window is resized to desktop
  $(window).on('resize', function () {
    if (window.innerWidth > 1024) {
      $('.nav-menu-wrapper').removeClass('is-open');
      $('.nav-toggle').attr('aria-expanded', 'false');
      $('.nav-menu > li.menu-item-has-children').removeClass('submenu-open');
      $('.nav-menu .sub-menu').removeClass('is-open');
    }
  });

  // Mega Menu Functionality (desktop only)
  let $activeMegaMenu = null;
  let $activeMegaMenuItem = null;

  $('.nav-menu > li.mega-menu-parent').each(function () {
    const $megaMenuItem = $(this);
    const $megaMenu = $megaMenuItem.find('.mega-menu-panel');

    if ($megaMenu.length) {
      $megaMenuItem.on('mouseenter', function () {
        // Only on desktop
        if (window.innerWidth > 1024) {
          // Hide any currently active mega menu and remove active class from parent
          if ($activeMegaMenu && $activeMegaMenu[0] !== $megaMenu[0]) {
            $activeMegaMenu.removeClass('active');
            if ($activeMegaMenuItem) {
              $activeMegaMenuItem.removeClass('mega-menu-active');
            }
          }
          // Show this mega menu and add active class to parent
          $megaMenu.addClass('active');
          $megaMenuItem.addClass('mega-menu-active');
          $activeMegaMenu = $megaMenu;
          $activeMegaMenuItem = $megaMenuItem;
        }
      });
    }
  });

  // Hide mega menu when leaving the navigation area entirely
  $('.main-nav').on('mouseleave', function () {
    if (window.innerWidth > 1024 && $activeMegaMenu) {
      $activeMegaMenu.removeClass('active');
      if ($activeMegaMenuItem) {
        $activeMegaMenuItem.removeClass('mega-menu-active');
      }
      $activeMegaMenu = null;
      $activeMegaMenuItem = null;
    }
  });

  // Hide mega menu when hovering over non-mega-menu items
  $('.nav-menu > li:not(.mega-menu-parent)').on('mouseenter', function () {
    if (window.innerWidth > 1024 && $activeMegaMenu) {
      $activeMegaMenu.removeClass('active');
      if ($activeMegaMenuItem) {
        $activeMegaMenuItem.removeClass('mega-menu-active');
      }
      $activeMegaMenu = null;
      $activeMegaMenuItem = null;
    }
  });

  // Animated counter for grid items with "calculate" class
  $('.grid-item.calculate').each(function () {
    const $counter = $(this).find('.grid-item-heading');

    // Configuration
    const baseNumber = 2887111485; // Starting number from design
    const dailyIncrement = 9.33 * 86400; // 9.33 per second * seconds in a day
    const perSecondIncrement = 9.33;
    const launchDate = new Date('2026-04-01'); // Set your launch date here

    // Calculate current value based on days since launch
    const now = new Date();
    const daysSinceLaunch = (now - launchDate) / (1000 * 60 * 60 * 24);
    const currentValue = Math.round(baseNumber + (dailyIncrement * daysSinceLaunch));

    let counter = currentValue;

    // Format number with commas
    function formatNumber(num) {
      return Math.round(num).toLocaleString('en-US');
    }

    // Set initial value
    $counter.text('$' + formatNumber(counter));

    // Increment counter every second
    setInterval(function () {
      counter += perSecondIncrement;
      $counter.text('$' + formatNumber(counter));
    }, 1000);
  });

  // Parallax motion for image-section cover images
  const $parallaxSections = $('.image-section.image-section--parallax');
  if ($parallaxSections.length) {
    let ticking = false;

    const isDesktop = () => window.innerWidth > 1024;
    const speedMap = {
      slow: 0.4,
      normal: 0.7,
      fast: 1.1,
    };

    const updateParallax = function () {
      const desktop = isDesktop();

      $parallaxSections.each(function () {
        const $section = $(this);
        const $image = $section.find('.image-section__image--background');

        if (!$image.length) {
          return;
        }

        const mobileEnabled = $section.data('parallax-mobile') === 1 || $section.data('parallax-mobile') === '1';
        if (!desktop && !mobileEnabled) {
          $image.css('transform', 'none');
          return;
        }

        const sectionRect = this.getBoundingClientRect();
        const sectionHeight = $section.outerHeight();
        const imageHeight = $image.outerHeight();
        const maxShift = Math.max(0, imageHeight - sectionHeight);
        const sectionTop = sectionRect.top + window.scrollY;
        const scrollRelative = window.scrollY + window.innerHeight - sectionTop;
        const totalDistance = window.innerHeight + sectionHeight;
        const progress = Math.min(1, Math.max(0, scrollRelative / totalDistance));
        const maxOffset = parseInt($section.data('parallax-max-offset'), 10) || 0;
        const cappedShift = maxOffset > 0 ? Math.min(maxShift, maxOffset) : maxShift;
        const speedKey = $section.data('parallax-speed') || 'normal';
        const speed = speedMap[speedKey] || speedMap.normal;
        const yOffset = Math.round((progress - 0.5) * cappedShift * speed);

        let baseTransform = 'translate3d(-50%, -50%, 0)';
        if ($section.hasClass('image-section--parallax-align-top')) {
          baseTransform = 'translate3d(-50%, 0, 0)';
        } else if ($section.hasClass('image-section--parallax-align-bottom')) {
          baseTransform = 'translate3d(-50%, -100%, 0)';
        }

        $image.css('transform', baseTransform + ' translateY(' + yOffset + 'px)');
      });
      ticking = false;
    };

    const requestTick = function () {
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    };

    $(window).on('scroll resize', requestTick);
    requestTick();
  }

});

